import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-secure-component',
  templateUrl: './secure-component.component.html',
  styleUrls: ['./secure-component.component.scss']
})
export class SecureComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
